import React, { lazy, Suspense, useEffect, useState } from "react";
import { useAppSelector } from "@litres-core/store";
import { getCookie } from "@litres/utils";
import { SkeletonBlock } from "@litres/ui-kit/skeleton";
import { useVarioqubTest } from "@litres-libs/experiments";
import { MainPromoBanner } from "./MainPromoBanner/MainPromoBanner";
import { EShowBanner } from "./utils";
import { useMainBanner } from "./useMainBanner";
import styles from "./Banners.module.scss";

const CountdownBanner = lazy(() => import("./CountdownBanner/CountdownBanner"));

interface IBannersProps {
  isVisible?: boolean;
}

export const Banners = ({ isVisible = true }: IBannersProps) => {
  const offers = useAppSelector(state => state.user.offers);
  const countdownOffer = offers.offersList.filter(item => {
    return item.campaign === 8 && item.class === 3;
  })[0];

  const [shouldShowCountdown, setShouldShowCountdown] = useState(false);

  useEffect(() => {
    setShouldShowCountdown(
      typeof countdownOffer?.discount !== "undefined" &&
        !getCookie("hide_countdown_banner") &&
        Boolean(countdownOffer.validTillTimestamp)
    );
  }, [countdownOffer]);

  const onChangeIsShowCountdown = (isShow: boolean) => {
    setShouldShowCountdown(isShow);
  };

  return (
    <div className={isVisible ? undefined : styles.hidden}>
      {shouldShowCountdown && (
        <Suspense fallback={<SkeletonBlock height="100%" width="100%" />}>
          <CountdownBanner
            offer={countdownOffer}
            onChangeIsShow={onChangeIsShowCountdown}
          />
        </Suspense>
      )}
      <MainBanner />
    </div>
  );
};

const MainBanner = () => {
  const mainBanner = useMainBanner();
  const isHeaderBannerPDAAB = useVarioqubTest("banner_header_pda", "false");
  const isHeaderBannerWebAB = useVarioqubTest("banner_header_www", "false");
  const isBannerABtest = isHeaderBannerPDAAB || isHeaderBannerWebAB;

  if (!isBannerABtest && mainBanner === EShowBanner.MAIN_PROMO) {
    return <MainPromoBanner />;
  }

  return null;
};
